module.exports = __webpack_public_path__ + "img/logo_happily_dark.18236334.png";